import type { Product } from "#lib/types/products.js";

export const sortCriteria = [
	{ field: "Popularitet", order: "desc", key: "popularity" },
	{ field: "Alfabetisk (A - Å)", order: "asc", key: "title" },
	{ field: "Alfabetisk (Å - A)", order: "desc", key: "title" },
	{ field: "Pris (lav - høy)", order: "asc", key: "price" },
	{ field: "Pris (høy - lav)", order: "desc", key: "price" },
];
export const selectedSort = $state({ sort: sortCriteria[0] });

export function sortProducts(
	products: Readonly<Product[]>,
	sort: (typeof sortCriteria)[number]
): Product[] {
	return [...products].sort((a, b) => {
		if (sort.key === "price") {
			return sort.order === "asc" ? a.price - b.price : b.price - a.price;
		} else if (sort.key === "title") {
			const comparison = a.title.localeCompare(b.title);
			return sort.order === "asc" ? comparison : -comparison;
		} else if (sort.key === "popularity") {
			const aPop = a.popularity ?? 0;
			const bPop = b.popularity ?? 0;
			if (aPop === 0 && bPop === 0) return 0;
			const popDiff = sort.order === "desc" ? bPop - aPop : aPop - bPop;
			if (popDiff !== 0) return popDiff;
			return a.title.localeCompare(b.title);
		}
		return 0;
	});
}
